import {computed, ref} from 'vue';

import type {TId} from '@/assets/core/assets/api/types';

import type {IActiveStatesItem} from '@/services/state/active_states/types';

export const useActiveStatesStateHook = () => {
  const activeStates = ref<IActiveStatesItem[]>([]);

  const getActiveStates = computed(() => activeStates.value);

  const addActiveState = (item: IActiveStatesItem) => {
    activeStates.value = activeStates.value.filter((val) => val.id !== item.id);
    activeStates.value.push(item);
  };

  const removeActiveState = (id: TId) => {
    activeStates.value.find((item) => item.id === id)?.cancelHandler?.()?.();
    activeStates.value = activeStates.value.filter((item) => item.id !== id);
  };

  return {
    getActiveStates,

    addActiveState,
    removeActiveState,
  };
};

export const activeStatesState = useActiveStatesStateHook();
